import { HeaderProps } from "@/src/layout/header/desktop/v1";

export const menuItemsProps: HeaderProps["menuItems"] = [
  // {
  //   title: 'Home',
  //   subMenuItems: [
  //     {
  //       label: 'Home One',
  //       href: '/',
  //     },
  //     {
  //       label: 'Home Two',
  //       href: '/home-2',
  //     },
  //   ],
  // },
  {
    label: "Home",
    href: "/en",
  },
  {
    label: "About",
    href: "/en/about",
  },
  {
    label: "Services",
    href: "/en/services",
  },
  {
    label: "Solutions",
    href: "/en/solutions",
  },
  {
    label: "Projects",
    href: "/en/project",
  },
    {
    label: "News",
    href: "/en/news",
  },
  {
    label: "Careers",
    href: "/en/careers",
  },

  // {
  //   label: 'Blogs',
  //   href: '/blog',
  // },
  // {
  //   title: 'Pages',
  //   subMenuItems: [
  //     {
  //       label: 'Testimonial',
  //       href: '/testimonial',
  //     },
  //     {
  //       label: 'Team',
  //       href: '/team',
  //     },
  //     {
  //       label: 'Pricing',
  //       href: '/pricing',
  //     },
  //     {
  //       label: 'FAQ',
  //       href: '/faq',
  //     },
  //   ],
  // },
  {
    label: "Contact",
    href: "/en/contact",
  },
];
